import { render } from "./OpportunitaEditDialog.vue?vue&type=template&id=539e1b52"
import script from "./OpportunitaEditDialog.vue?vue&type=script&lang=js"
export * from "./OpportunitaEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__